<template>
  <div v-if="resource !== null">
    <div class="grid grid-cols-1 gap-6">
      <vx-card title="Transacciones">
        <div class="row">
          <div class="col-md-6">
            <vs-table :data="resource.commissions.applicant.items" stripe>
              <template slot="thead">
                <vs-th>TRX</vs-th>
                <vs-th>Concepto</vs-th>
                <vs-th class="w-1/5">Monto</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-divider>Solicitante</vs-divider>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="trx in data">
                  <vs-td>{{ trx.trx_type }}</vs-td>
                  <vs-td>{{ trx.concept }}</vs-td>
                  <vs-td class="w-1/5 text-right">{{ trx.amount | currency }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td></vs-td>
                  <vs-td class="text-right font-bold">Total:</vs-td>
                  <vs-td class="w-1/5 text-right font-bold">{{ resource.commissions.applicant.amount | currency
                    }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-divider>Inversionista</vs-divider>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="itrx in resource.commissions.investor.items">
                  <vs-td>{{ itrx.trx_type }}</vs-td>
                  <vs-td>{{ itrx.concept }}</vs-td>
                  <vs-td class="w-1/5 text-right">{{ itrx.amount | currency }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td></vs-td>
                  <vs-td class="text-right font-bold">Total:</vs-td>
                  <vs-td class="w-1/5 text-right font-bold">{{ resource.commissions.investor.amount | currency
                    }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div class="col-md-6">
            <vs-table :data="resource.bonus.applicant.items" stripe>
              <template slot="thead">
                <vs-th>TRX</vs-th>
                <vs-th>Concepto</vs-th>
                <vs-th class="w-1/5">Monto</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-divider>Solicitante</vs-divider>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="bonusTrx in data">
                  <vs-td>{{ bonusTrx.trx_type }}</vs-td>
                  <vs-td>{{ bonusTrx.concept }}</vs-td>
                  <vs-td class="w-1/5 text-right">{{ bonusTrx.amount | currency }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td></vs-td>
                  <vs-td class="text-right font-bold">Total:</vs-td>
                  <vs-td class="w-1/5 text-right font-bold">{{ resource.bonus.applicant.amount | currency }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td colspan="3">
                    <vs-divider>Inversionista</vs-divider>
                  </vs-td>
                </vs-tr>
                <vs-tr v-for="ibonusTrx in resource.bonus.investor.items">
                  <vs-td>{{ ibonusTrx.trx_type }}</vs-td>
                  <vs-td>{{ ibonusTrx.concept }}</vs-td>
                  <vs-td class="w-1/5 text-right">{{ ibonusTrx.amount | currency }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td></vs-td>
                  <vs-td class="text-right font-bold">Total:</vs-td>
                  <vs-td class="w-1/5 text-right font-bold">{{ resource.bonus.investor.amount | currency }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="grid grid-cols-1 gap-6 content-end mt-4">
      <vs-card>
        <vs-table :data="[{}]">
          <template slot="header">
            <vs-th>TRX</vs-th>
            <vs-th>Concepto</vs-th>
            <vs-th>Monto</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr>
              <vs-td>R210</vs-td>
              <vs-td>{{ resource.r210_concept }}</vs-td>
              <vs-td>{{ resource.total_transaction_amount | currency }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>


        <vs-button :disabled="resource.total_transaction_amount < 0" @click="showDialog = true"
          class="mt-4 float-right">
          Generar R210
        </vs-button>
        <vs-button class="mt-4 float-right mr-2 mb-2" @click="exportCsvHandle">
          Exportar a CSV
        </vs-button>
      </vs-card>
    </div>

    <vs-popup title="Confirmación" :active.sync="showDialog">
      <div class="text-lg text-gray-900 pb-6">
        Se va a realizar un TRX R210 por un monto de {{ resource.total_transaction_amount | currency }} MXN
      </div>

      <vs-button class="mt-6 float-right" @click="generateTransactionHandler">
        Confirmar
      </vs-button>
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "recurrent-commission-results",
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    resource: null,
    showDialog: false,
    startDate: null,
    endDate: null,
    payment: null,
    applicantCommissionGroupId: 1,
    applicantBonusGroupId: 2,
    investorCommissionGroupId: 3,
    investorBonusGroupId: 4,
  }),
  methods: {
    /**
     * @param {Date} startDate
     * @param {Date} endDate
     * @returns {Promise<void>}
     */
    async fetchCommission(startDate, endDate) {
      this.$vs.loading();
      this.startDate = startDate;
      this.endDate = endDate;

      try {
        const { data } = await axios.post(`/api/recurrent-commission`, {
          start_date: moment(this.startDate).format('YYYY-MM-DD'),
          end_date: moment(this.endDate).format('YYYY-MM-DD'),
          applicant_commission_group_id: this.applicantCommissionGroupId,
          applicant_bonus_group_id: this.applicantBonusGroupId,
          investor_commission_group_id: this.investorCommissionGroupId,
          investor_bonus_group_id: this.investorBonusGroupId,
        })

        this.resource = data;
      } catch (e) {
        swal('Error', e.response.data.error, 'error')
      } finally {
        this.$vs.loading.close();
      }
    },
    async generateTransactionHandler() {
      this.$vs.loading();
      try {
        const { data } = await axios.post(
          `/api/recurrent-commission/disperse`, {
          start_date: moment(this.startDate).format('YYYY-MM-DD'),
          end_date: moment(this.endDate).format('YYYY-MM-DD'),
          applicant_commission_group_id: this.applicantCommissionGroupId,
          applicant_bonus_group_id: this.applicantBonusGroupId,
          investor_commission_group_id: this.investorCommissionGroupId,
          investor_bonus_group_id: this.investorBonusGroupId,
          amount: parseFloat(this.resource.total_transaction_amount).toFixed(2)
        }
        )
        this.payment = data;
        swal('Ok', 'El R210 se creó correctamente', 'success')
        await this.fetchCommission(this.startDate, this.endDate)
      } catch (e) {
        swal('Error', e.message, 'error')
      } finally {
        this.$vs.loading.close();
        this.showDialog = false;
      }
    },
    async exportCsvHandle() {
      const params = {
        start_date: this.startDate,
        end_date: this.endDate,
        applicant_commission_group_id: this.applicantCommissionGroupId,
        applicant_bonus_group_id: this.applicantBonusGroupId,
        investor_commission_group_id: this.investorCommissionGroupId,
        investor_bonus_group_id: this.investorBonusGroupId,
      };

      const paramURL = new URLSearchParams(params).toString();
      window.open(
        `${process.env.VUE_APP_API_DOMAIN}/api/recurrent-commission/export?${paramURL}`,
        '_blank'
      )
    }
  }
}
</script>
